export { default } from './VendorRequestDrawerBody';
